import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ActionPlanTaskExtraRequest,
  ActionPlanTaskInfoResponse,
  mapActionPlanTaskInfo,
  RawActionPlanTaskInfoResponse,
} from '@maximizer/core/shared/domain';
import { map, Observable } from 'rxjs';
import { ContextService } from './context.service';

@Injectable()
export class ActionPlanTaskService {
  constructor(
    private readonly http: HttpClient,
    private readonly context: ContextService,
  ) {}

  getInfo(
    taskKey: string,
    actionPlanKey: string,
  ): Observable<ActionPlanTaskInfoResponse> {
    const body = new HttpParams()
      .set('taskKey', taskKey)
      .set('actionPlanKey', actionPlanKey);
    return this.http
      .post<RawActionPlanTaskInfoResponse>(
        `${this.context.website}/mvc/InteractionTask/InteractionTask/GetActionPlanInfo`,
        body.toString(),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          withCredentials: true,
        },
      )
      .pipe(
        map((raw) => ({
          success: raw.success,
          status: raw.status,
          title: raw.title,
          actionPlanInfo: raw.actionPlanInfo
            ? mapActionPlanTaskInfo(raw.actionPlanInfo)
            : null,
        })),
      );
  }

  extraRequestForTask(
    request: ActionPlanTaskExtraRequest,
  ): Observable<unknown> {
    const body = new HttpParams()
      .set('taskKey', request.taskKey)
      .set('reassignFromUser', request.reassignFromUser ?? '')
      .set('reassignToUser', request.reassignToUser ?? '')
      .set('isModify', String(request.isModify))
      .set('completeDelay', request.completeDelay)
      .set('isProcessingActionPlan', String(request.isProcessingActionPlan))
      .set('dependentRescheduleFlag', String(request.dependentRescheduleFlag))
      .set('originaldate', request.originalDate)
      .set('completed', String(request.completed))
      .set('preDDValue', request.preDateDisplayValue)
      .set('preActValue', request.preActivityValue);
    return this.http.post<unknown>(
      `${this.context.website}/mvc/InteractionTask/InteractionTask/ExtraRequestForTask`,
      body.toString(),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        withCredentials: true,
      },
    );
  }

}
